import React from "react";
import {useSelector} from "react-redux";
import {RouteComponentProps} from "react-router";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {PaginationWithList} from "@pg-design/pagination";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {SiteMapBoxList} from "../components/SiteMapBoxList";
import {SiteMapHeading} from "../components/SiteMapHeading";

export const getSitemapArticleBreadcrumbs = (categorySlug?: string, categoryName?: string) => {
    return [
        {
            key: "mapa-strony",
            name: "Mapa strony",
            position: "2",
            url: rpAppLink.siteMap.base()
        },
        {
            key: "mapa-strony-artykuły",
            name: "Mapa strony - Artykuły",
            position: "3",
            url: rpAppLink.siteMap.article.base()
        },
        ...(categorySlug && categoryName
            ? [
                  {
                      key: `artykuły-${categoryName}`,
                      name: `Artykuły - ${categoryName}`,
                      position: "4",
                      url: rpAppLink.siteMap.article.category({categorySlug: categorySlug})
                  }
              ]
            : [])
    ];
};

interface IProps extends RouteComponentProps<{}> {}

export const SiteMapArticleCategory = (props: IProps) => {
    const {categorySlug} = props.match.params as {categorySlug: string};
    const articleCategories = useSelector((state: IRPStore) => state.siteMap?.articleCategories);
    const articles = useSelector((state: IRPStore) => state.siteMap?.articles);
    const categoryObj = articleCategories.find((category) => category.slug === categorySlug);

    if (!categoryObj) {
        return null;
    }

    const parsedSearch = parseSearch(props.location.search);
    const buildPageLink = (page: number) => {
        const query = validateQuery(["page"], parsedSearch, page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(props.location.pathname, query);
    };
    const currentPage = parsedSearch.page || 1;

    const breadcrumbs = getSitemapArticleBreadcrumbs(categorySlug, categoryObj.name);

    const siteMapRecords =
        articles?.list?.map((article) => ({
            href: rpAppLink.article.detail({
                articleSlug: article.slug,
                articleId: article.id
            }),
            header: article.title,
            text: `${article.author && article.author.name} - ${formatDate(article.create_date, dateTimeFormat.shortDate)}`
        })) || [];

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                {breadcrumbs.map((breadcrumb, index) => (
                    <BreadcrumbsItem {...breadcrumb} key={breadcrumb.key} isLinkingToCurrentLocation={breadcrumbs.length - 1 === index} />
                ))}
            </Breadcrumbs>
            <article>
                <SiteMapHeading>Artykuły - {categoryObj.name}</SiteMapHeading>

                <SiteMapBoxList records={siteMapRecords} css={[mb(4)]} />
                <PaginationWithList
                    pageCount={Math.ceil(articles.count / articles.page_size)}
                    currentPage={parseInt(currentPage as string, 10)}
                    hrefBuilder={buildPageLink}
                    iconPrev={<ChevronLeftIcon />}
                    iconNext={<ChevronRightIcon />}
                    multiNumbersInside
                    css={[mb(4)]}
                />
            </article>
        </Container>
    );
};
import React from "react";
import {useSelector} from "react-redux";
import {RouteComponentProps} from "react-router";

import {Container} from "@pg-design/grid-module";
import {mb} from "@pg-design/helpers-css";
import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {PaginationWithList} from "@pg-design/pagination";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {Breadcrumbs} from "../../app/components/breadcrumbs/Breadcrumbs";
import {BreadcrumbsItem} from "../../app/components/breadcrumbs/BreadcrumbsItem";
import {IRPStore} from "../../app/rp_reducer";
import {SiteMapBoxList} from "../components/SiteMapBoxList";
import {SiteMapHeading} from "../components/SiteMapHeading";

export const getSitemapArticleBreadcrumbs = (categorySlug?: string, categoryName?: string) => {
    return [
        {
            key: "mapa-strony",
            name: "Mapa strony",
            position: "2",
            url: rpAppLink.siteMap.base()
        },
        {
            key: "mapa-strony-artykuły",
            name: "Mapa strony - Artykuły",
            position: "3",
            url: rpAppLink.siteMap.article.base()
        },
        ...(categorySlug && categoryName
            ? [
                  {
                      key: `artykuły-${categoryName}`,
                      name: `Artykuły - ${categoryName}`,
                      position: "4",
                      url: rpAppLink.siteMap.article.category({categorySlug: categorySlug})
                  }
              ]
            : [])
    ];
};

interface IProps extends RouteComponentProps<{}> {}

export const SiteMapArticleCategory = (props: IProps) => {
    const {categorySlug} = props.match.params as {categorySlug: string};
    const articleCategories = useSelector((state: IRPStore) => state.siteMap?.articleCategories);
    const articles = useSelector((state: IRPStore) => state.siteMap?.articles);
    const categoryObj = articleCategories.find((category) => category.slug === categorySlug);

    if (!categoryObj) {
        return null;
    }

    const parsedSearch = parseSearch(props.location.search);
    const buildPageLink = (page: number) => {
        const query = validateQuery(["page"], parsedSearch, page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(props.location.pathname, query);
    };
    const currentPage = parsedSearch.page || 1;

    const breadcrumbs = getSitemapArticleBreadcrumbs(categorySlug, categoryObj.name);

    const siteMapRecords =
        articles?.list?.map((article) => ({
            href: rpAppLink.article.detail({
                articleSlug: article.slug,
                articleId: article.id
            }),
            header: article.title,
            text: `${article.author && article.author.name} - ${formatDate(article.create_date, dateTimeFormat.shortDate)}`
        })) || [];

    return (
        <Container>
            <Breadcrumbs homePageUrl={rpAppLink.base()}>
                {breadcrumbs.map((breadcrumb, index) => (
                    <BreadcrumbsItem {...breadcrumb} key={breadcrumb.key} isLinkingToCurrentLocation={breadcrumbs.length - 1 === index} />
                ))}
            </Breadcrumbs>
            <article>
                <SiteMapHeading>Artykuły - {categoryObj.name}</SiteMapHeading>

                <SiteMapBoxList records={siteMapRecords} css={[mb(4)]} />
                <PaginationWithList
                    pageCount={Math.ceil(articles.count / articles.page_size)}
                    currentPage={parseInt(currentPage as string, 10)}
                    hrefBuilder={buildPageLink}
                    iconPrev={<ChevronLeftIcon />}
                    iconNext={<ChevronRightIcon />}
                    multiNumbersInside
                    css={[mb(4)]}
                />
            </article>
        </Container>
    );
};
